import axios from "@/api/http";
/** Homepage builder API helpers (admin JWT from localStorage, like the rest of the panel) */
function auth() {
  return { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } }
}

export function getHomepage() {
  return axios.get('/api/admin/homepage', auth())
}
export function getDefaultHomepage() {
  return axios.get('/api/admin/homepage/default', auth())
}
export function saveHomepage(config) {
  return axios.put('/api/admin/homepage', { config: config }, auth())
}
export function uploadHomepageImage(file) {
  const fd = new FormData()
  fd.append('file', file)
  return axios.post('/api/admin/homepage/upload', fd, auth())
}
export function searchProducts(search, perPage) {
  const fd = new FormData()
  fd.append('search', search || '')
  fd.append('page', '1')
  fd.append('per_page', String(perPage || 20))
  return axios.post('/api/admin/product/get_products', fd, Object.assign({ show_pros: false }, auth()))
}
export function getCategoryTree() {
  return axios.post('/api/admin/product/get_categories_with_children', new FormData(), auth())
}

export const SECTION_TYPES = [
  { value: 'hero_slider', label: 'اسلایدر اصلی' },
  { value: 'banner_grid', label: 'بنرهای شبکه‌ای' },
  { value: 'category_icons', label: 'آیکون دسته‌بندی‌ها' },
  { value: 'amazing_offers', label: 'پیشنهاد شگفت‌انگیز' },
  { value: 'product_carousel', label: 'ردیف محصولات (اسلایدر)' },
  { value: 'brand_strip', label: 'نوار برندها' },
  { value: 'story_circles', label: 'استوری‌ها (دایره‌ای)' },
  { value: 'shipping_info', label: 'نوار خدمات و ارسال' },
  { value: 'html_block', label: 'بلوک HTML' }
]
export const DEVICES = [
  { value: 'all', label: 'همه دستگاه‌ها' },
  { value: 'desktop', label: 'فقط دسکتاپ' },
  { value: 'mobile', label: 'فقط موبایل' }
]
export const PRODUCT_SOURCES = [
  { value: 'newest', label: 'جدیدترین' },
  { value: 'bestselling', label: 'پرفروش‌ترین' },
  { value: 'discounted', label: 'تخفیف‌دار' },
  { value: 'top_category', label: 'دسته‌بندی اصلی (خودکار، به ترتیب درخت)' },
  { value: 'category', label: 'از یک دسته‌بندی' },
  { value: 'manual', label: 'انتخاب دستی' }
]

export function typeLabel(t) {
  const x = SECTION_TYPES.find(function (s) { return s.value === t })
  return x ? x.label : t
}

export function newSection(type) {
  const id = 's_' + Math.random().toString(16).slice(2, 12)
  const base = { id: id, type: type, title: typeLabel(type), enabled: true, order: 0, device: 'all', settings: {}, items: [] }
  if (type === 'hero_slider') base.settings = { autoplay: true, interval: 5000 }
  if (type === 'banner_grid') base.settings = { columns: 2 }
  if (type === 'amazing_offers') base.settings = { endsAt: '', bgColor: '', source: 'discounted', productIds: [], limit: 12, viewAllLink: '' }
  if (type === 'product_carousel') base.settings = { source: 'newest', categoryId: null, categoryIndex: 1, productIds: [], limit: 12, viewAllLink: '' }
  if (type === 'html_block') base.settings = { html: '' }
  if (type === 'category_icons') base.settings = { auto: true, limit: 12 }
  if (type === 'brand_strip') base.settings = { auto: true, limit: 20 }
  if (type === 'shipping_info') base.settings = { bgColor: '' }
  return base
}

export function newItem(type) {
  if (type === 'category_icons') return { categoryId: null, title: '', icon: '', link: '' }
  if (type === 'brand_strip') return { title: '', logo: '', link: '' }
  if (type === 'story_circles') return { title: '', image: '', link: '' }
  if (type === 'shipping_info') return { icon: 'delivery', image: '', title: '', subtitle: '', link: '' }
  return { image: '', mobileImage: '', link: '', alt: '' }
}

export const SHIPPING_ICONS = [
  { value: 'delivery', label: 'ارسال سریع' },
  { value: 'support', label: 'پشتیبانی' },
  { value: 'cod', label: 'پرداخت در محل' },
  { value: 'return', label: 'بازگشت کالا' },
  { value: 'original', label: 'ضمانت اصالت' },
  { value: 'gift', label: 'هدیه' },
  { value: 'secure', label: 'پرداخت امن' }
]
